import React from 'react'
import s from './EmptyMessage.scss'
import sText from 'components/Text/Text.scss'

export default () => (
  <div className={s.card}>
    <div className={sText.descrip2}>This flow is empty</div>
    <p className={sText.descrip3}>
      Click and drag an <b>trigger</b> from the sidebar to get started. If this is your first flow,
      read the{' '}
      <a href="https://help.thinkpickle.com.au/flows" target="_blank" rel="noopener noreferrer">
        help documentation.
      </a>
    </p>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/EmptyMessage/EmptyMessage.jsx